import { render } from "./HoldersTableRow.vue?vue&type=template&id=3835119c&scoped=true"
import script from "./HoldersTableRow.vue?vue&type=script&lang=js"
export * from "./HoldersTableRow.vue?vue&type=script&lang=js"

import "./HoldersTableRow.vue?vue&type=style&index=0&id=3835119c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3835119c"

export default script